import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19137 20944"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:232.091}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <path
      d="M11415 9852c36 1015-809 2014-1901 1901-1091-113-1784-922-1784-1850l47-1681 1120 7V7016c-1187-293-1913-1209-1971-2447-59-1238 344-1532 935-2092l26-2344 3459-16-36 2310c-16 0 912 741 912 2040s-847 2376-1963 2549v1212l1152 12 4 1612zM3481 15916l387 52 537 170v-387h1962v5077H4430l7-1135-909 175c-408 78-1012-135-1340-392l-2071 7 14-3164 2065 36c205-245 841-499 1285-439zM15656 15916l-386 52-538 170v-387h-1962v5077h1938l-8-1135 909 175c408 78 1012-135 1340-392l2071 7-14-3164-2065 36c-205-245-841-499-1285-439z"
      className="fill"
    />
  </svg>
);
export default SvgComponent;
